import * as React from 'react'
import { Grid, Header, Divider } from 'semantic-ui-react'

const MVV = () => (
  <Grid columns='equal'>
    <Grid.Column>
      <Grid.Row>
        <Header size='large'>Missão</Header>
        <p>
          Desenvolver soluções integradas para ambientes corporativos com alto
          padrão de excelência e confiabilidade.
        </p>
      </Grid.Row>
      <Grid.Row>
        <Divider hidden/>
        <Header size='large'>Visão</Header>
        <p>
          Ser referência no mercado pelo atendimento eficiente ao cliente, no
          cumprimento de prazos e expectativa de resultados.
        </p>
      </Grid.Row>
    </Grid.Column>
    <Grid.Column>
      <Header size='large'>Valores</Header>
      <ul>
        <li>Conexão integral e transparência na relação com o cliente;</li>
        <li>
          Comprometimento com o planejamento rigoroso no desenvolvimento dos
          projetos;
        </li>
        <li>
          Equipe participativa e motivada em ambiente de trabalho acolhedor;
        </li>
        <li>
          Respeito ao meio ambiente e prioridade nas soluções de
          sustentabilidade;
        </li>
        <li>Garantia de confidencialidade no trato comercial.</li>
      </ul>
    </Grid.Column>
  </Grid>
)

export default MVV
